import request from '@/utils/request'

//查询所有放映厅信息
export function gethall(params) {
  return request({
    url: '/api/film/hall',
    method: 'get',
    params
  });
}
//根据放映厅id查询电影
export function pageFilmByHall(params) {
  return request({
    url: '/api/film/pageFilmByHall',
    method: 'get',
    params
  });
}

//获取电影须知
export function getFilmTips(params) {
  return request({
    url: '/api/film/getFilmTips',
    method: 'get',
    params
  });
}

// 获取电影场次信息
export function listRound(params) {
  return request({
    url: '/api/film/listRound',
    method: 'get',
    params
  });
}
// 确认订单，结算订单金额
export function confirmOrder(data) {
  return request({
    url: '/api/film/confirmOrder',
    method: 'post',
    data
  });
}
// 个人单次购票上限
export function getFilmSetting(params) {
  return request({
    url: '/api/film/getFilmSetting',
    method: 'get',
    params
  });
}

// 提交订单
export function submitOrder(params) {
  return request({
    url: '/api/film/submitOrder',
    method: 'get',
    params
  });
}

// 购票成功后回调通知
export function successNotify(params) {
  return request({
    url: '/api/robot/film/successNotify',
    method: 'get',
    params
  });
}
// 微信扫码支付接口
export function wxNativePay(data) {
  return request({
    url: '/api/pay/wxNativePay',
    method: 'post',
    data
  });
}
// 查询支付单信息
export function queryPayOrder(data) {
  return request({
    url: '/api/pay/queryPayOrder',
    method: 'post',
    data
  });
}
//根据电影
export function pageFilms(params) {
  return request({
    url: '/api/film/pageFilms',
    method: 'get',
    params
  });
}


// WEBPACK FOOTER //
// ./src/api/cinema/index.js